// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pu-5";
export var filledCircle = "_pu-4";
export var historyEntry = "_pu-3";
export var messageSideLeft = "_pu-1";
export var messageSideRight = "_pu-2";
export var orderTrackingCarouselWrapper = "_pu-6";
export var orderTrackingInfoContainer = "_pu-0";